import React from 'react';
import { MinusIcon, PlusIcon, RotateCcwIcon, SaveIcon } from 'lucide-react';
interface PacingControlProps {
  pacingSpeed: number;
  setPacingSpeed: (speed: number) => void;
  isActive: boolean;
  onReset?: () => void;
  showSaved?: boolean;
  exerciseName?: string;
  isDefault?: boolean;
}
const PacingControl: React.FC<PacingControlProps> = ({
  pacingSpeed,
  setPacingSpeed,
  isActive,
  onReset,
  showSaved = false,
  exerciseName = '',
  isDefault = false
}) => {
  const decreaseSpeed = () => {
    if (pacingSpeed > 10) {
      setPacingSpeed(pacingSpeed - 5);
    }
  };
  const increaseSpeed = () => {
    if (pacingSpeed < 120) {
      setPacingSpeed(pacingSpeed + 5);
    }
  };
  return <div className="mt-6 p-4 bg-purple-50 rounded-lg relative" data-id="element-19">
      <h3 className="text-lg font-medium text-center mb-2" data-id="element-20">
        Pacing Speed for {exerciseName}
      </h3>
      <div className="flex items-center justify-between" data-id="element-21">
        <button onClick={decreaseSpeed} disabled={isActive || pacingSpeed <= 10} className="p-2 rounded-full bg-purple-200 hover:bg-purple-300 disabled:opacity-50" aria-label="Decrease speed" data-id="element-22">
          <MinusIcon size={20} data-id="element-23" />
        </button>
        <div className="text-center" data-id="element-24">
          <div className="text-3xl font-bold text-purple-800" data-id="element-25">
            {pacingSpeed}
          </div>
          <div className="text-sm text-gray-600" data-id="element-26">reps per minute</div>
          {isDefault ? <div className="text-xs text-purple-600 mt-1" data-id="element-27">(Default)</div> : <div className="text-xs text-purple-600 mt-1" data-id="element-28">(Custom)</div>}
        </div>
        <button onClick={increaseSpeed} disabled={isActive || pacingSpeed >= 120} className="p-2 rounded-full bg-purple-200 hover:bg-purple-300 disabled:opacity-50" aria-label="Increase speed" data-id="element-29">
          <PlusIcon size={20} data-id="element-30" />
        </button>
      </div>
      <div className="mt-4 flex justify-between items-center" data-id="element-31">
        <div className="text-sm text-gray-600" data-id="element-32">
          {isActive ? 'Pause to adjust speed' : 'Adjust before starting'}
        </div>
        {onReset && !isActive && !isDefault && <button onClick={onReset} className="flex items-center text-sm text-purple-700 hover:text-purple-900" aria-label="Reset to default" data-id="element-33">
            <RotateCcwIcon size={14} className="mr-1" data-id="element-34" /> Reset to default
          </button>}
      </div>
      {/* Saved indicator */}
      {showSaved && <div className="absolute top-0 right-0 transform -translate-y-1/2 bg-green-500 text-white px-3 py-1 rounded-full text-sm flex items-center shadow-md animate-pulse" data-id="element-35">
          <SaveIcon size={14} className="mr-1" data-id="element-36" /> Saved
        </div>}
    </div>;
};
export default PacingControl;